import { RequestConfig } from '~/common/services/requests';
import {
  PlatformRequestOptions,
  RequestsApi,
} from '../../../../contexts/RequestsContext';

export const constructDeleteRequest = async <ResponseType>(
  performRequest: RequestsApi['platformRequest'],
  deletePath: string,
  config?: RequestConfig,
  options?: PlatformRequestOptions,
): Promise<ResponseType | undefined> =>
  performRequest<ResponseType>(
    { method: 'DELETE', url: deletePath, ...config },
    options,
  );
